import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

// Whether the public index has anything in it. The "Disputes" nav/footer links
// and the /disputes page itself only exist once at least one decided dispute
// has been published — an empty index is a dead end, so we don't advertise it.
//
// Answered by GET /api/share?limit=1 (unauthenticated; `total` is the count of
// publicly visible disputes). The result is cached at module scope: the header
// and the footer both ask on every page, and the count can't change under a
// visitor mid-session. It's re-fetched on a full page load, which is when a
// filer who just published their case would see the links appear.
//
// Defaults to hidden while loading — the opposite of usePublicAccess, because
// showing a link and then yanking it away is worse than showing it a beat late.

let cached = null;
let inflight = null;

function fetchCount() {
  if (cached !== null) return Promise.resolve(cached);
  if (!inflight) {
    inflight = fetch(`${API_BASE}/api/share?limit=1`)
      .then((res) => (res.ok ? res.json() : { total: 0 }))
      .then((data) => {
        cached = Number(data.total) || 0;
        return cached;
      })
      .catch(() => 0)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useHasPublicDisputes() {
  const [has, setHas] = useState(cached !== null && cached > 0);

  useEffect(() => {
    let cancelled = false;
    fetchCount().then((n) => {
      if (!cancelled) setHas(n > 0);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return has;
}
